"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const markFlatFunctions_1 = require("./markFlatFunctions");
const markAnnotated_1 = require("./markAnnotated");
const markFlatApplications_1 = require("./markFlatApplications");
const util_1 = require("@stopify/util");
const visitor = {
    Program(path) {
        util_1.transformFromAst(path, [markAnnotated_1.markAnnotated]);
        util_1.transformFromAst(path, [[markFlatFunctions_1.markFlatFunctions]]);
        util_1.transformFromAst(path, [markFlatApplications_1.markFlatApplications]);
    }
};
function flatness() {
    return {
        visitor: visitor
    };
}
exports.flatness = flatness;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmxhdG5lc3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcGlsZXIvZmxhdG5lc3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSwyREFBd0Q7QUFDeEQsbURBQWdEO0FBQ2hELGlFQUE4RDtBQUM5RCx3Q0FBaUQ7QUFFakQsTUFBTSxPQUFPLEdBQVk7SUFDdkIsT0FBTyxDQUFDLElBQXlCO1FBQzdCLHVCQUFnQixDQUFDLElBQUksRUFBRSxDQUFFLDZCQUFhLENBQUUsQ0FBQyxDQUFDO1FBQzFDLHVCQUFnQixDQUFDLElBQUksRUFBRSxDQUFFLENBQUMscUNBQWlCLENBQUMsQ0FBRSxDQUFDLENBQUM7UUFDaEQsdUJBQWdCLENBQUMsSUFBSSxFQUFFLENBQUUsMkNBQW9CLENBQUUsQ0FBQyxDQUFDO0lBQ3JELENBQUM7Q0FDRixDQUFDO0FBRUYsU0FBZ0IsUUFBUTtJQUN0QixPQUFPO1FBQ0wsT0FBTyxFQUFFLE9BQU87S0FDakIsQ0FBQztBQUNKLENBQUM7QUFKRCw0QkFJQyJ9


//////////////////
// WEBPACK FOOTER
// .-continuations-compiler/dist/src/compiler/flatness.js
// module id = 807
// module chunks = 0